(function(){
  'use strict';

  function ready(fn){
    if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',fn,{once:true});
    else fn();
  }

  function getCurrency(){
    return (window.Shopify&&Shopify.currency&&Shopify.currency.active)||'USD';
  }

  function money(cents){
    var value=Number(cents||0)/100;
    try{
      return new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:getCurrency()}).format(value);
    }catch(e){
      return '$'+value.toFixed(2);
    }
  }

  function ensureCartBubble(cartLink){
    if(!cartLink) return null;
    var bubble=cartLink.querySelector('[data-dp-cart-count]');
    if(!bubble){
      bubble=document.createElement('span');
      bubble.className='dp-cro-cart-count';
      bubble.setAttribute('data-dp-cart-count','');
      bubble.setAttribute('aria-hidden','true');
      cartLink.appendChild(bubble);
    }
    return bubble;
  }

  function syncCartBadges(cart){
    var count=cart&&Number(cart.item_count)||0;
    document.querySelectorAll('[data-dp-cro-cart]').forEach(function(link){
      var bubble=ensureCartBubble(link);
      if(!bubble) return;
      bubble.textContent=String(count);
      bubble.setAttribute('data-count',String(count));
      bubble.style.display=count>0?'grid':'none';
    });
    document.querySelectorAll('.dp-cart-bubble').forEach(function(bubble){
      bubble.textContent=String(count);
      bubble.setAttribute('data-count',String(count));
      bubble.style.display=count>0?'':'none';
    });
  }

  var cartSyncTimer=0;
  function fetchCart(){
    return fetch('/cart.js?dp_cro_sync='+Date.now(),{headers:{Accept:'application/json'},credentials:'same-origin'})
      .then(function(r){if(!r.ok) throw new Error('cart');return r.json();})
      .then(function(cart){syncCartBadges(cart);return cart;})
      .catch(function(){return null;});
  }

  function scheduleCartSync(){
    window.clearTimeout(cartSyncTimer);
    cartSyncTimer=window.setTimeout(fetchCart,100);
  }

  function initCartSync(){
    fetchCart();
    window.addEventListener('pageshow',scheduleCartSync);
    document.addEventListener('cart:updated',scheduleCartSync);
    document.addEventListener('cart:refresh',scheduleCartSync);
    var drawer=document.querySelector('cart-drawer');
    if(drawer&&window.MutationObserver){
      new MutationObserver(scheduleCartSync).observe(drawer,{childList:true,subtree:true});
    }
  }

  function productHandle(){
    var m=window.location.pathname.match(/\/products\/([^\/?#]+)/i);
    return m?decodeURIComponent(m[1]):'';
  }

  function productJsonPath(handle){
    var path=window.location.pathname;
    var i=path.toLowerCase().indexOf('/products/');
    if(i<0) return '/products/'+encodeURIComponent(handle)+'.js';
    return path.slice(0,i)+'/products/'+encodeURIComponent(handle)+'.js';
  }

  function allocationPlanId(allocation){
    if(!allocation) return '';
    if(allocation.selling_plan_id!=null) return String(allocation.selling_plan_id).replace(/\D/g,'');
    if(allocation.selling_plan&&allocation.selling_plan.id!=null) return String(allocation.selling_plan.id).replace(/\D/g,'');
    return '';
  }

  function allocationPrice(allocation){
    if(!allocation) return null;
    var p=allocation.price;
    if(p==null&&allocation.per_delivery_price!=null) p=allocation.per_delivery_price;
    p=Number(p);
    return Number.isFinite(p)?p:null;
  }

  function initProductPurchaseIntegrity(){
    var section=document.querySelector('[id^="dp-product-"]');
    var handle=productHandle();
    if(!section||!handle) return;

    var purchaseGroup=section.querySelector('[data-dp-purchase-options]');
    var sellingPlanHidden=section.querySelector('[data-dp-selling-plan-input]');

    if(handle==='dental-wipe-packs'&&purchaseGroup){
      purchaseGroup.hidden=true;
      purchaseGroup.setAttribute('aria-hidden','true');
      purchaseGroup.querySelectorAll('[data-dp-purchase-option]').forEach(function(input){input.checked=input.value==='one-time';});
      if(sellingPlanHidden) sellingPlanHidden.value='';
    }

    if(!purchaseGroup||handle==='dental-wipe-packs') return;

    fetch(productJsonPath(handle),{headers:{Accept:'application/json'},credentials:'same-origin'})
      .then(function(r){if(!r.ok) throw new Error('product');return r.json();})
      .then(function(productData){
        var variants=Array.isArray(productData.variants)?productData.variants:[];
        if(!variants.length) return;
        var byId={};
        variants.forEach(function(v){byId[String(v.id).replace(/\D/g,'')]=v;});

        var planInputs=Array.prototype.slice.call(section.querySelectorAll('[data-dp-purchase-option]'));
        var oneTime=planInputs.find(function(input){return !input.getAttribute('data-selling-plan-id');});
        var priceEl=section.querySelector('[data-dp-price]');
        var compareEl=section.querySelector('[data-dp-compare]');

        function selectedVariantInput(){
          return section.querySelector('input[name="id"]:checked')||section.querySelector('input[type="hidden"][name="id"]');
        }

        function selectedVariant(){
          var input=selectedVariantInput();
          return input?byId[String(input.value).replace(/\D/g,'')]:null;
        }

        function allocationsFor(variant){
          return variant&&Array.isArray(variant.selling_plan_allocations)?variant.selling_plan_allocations:[];
        }

        function findAllocation(variant,planId){
          var clean=String(planId||'').replace(/\D/g,'');
          return allocationsFor(variant).find(function(a){return allocationPlanId(a)===clean;})||null;
        }

        function flattenNote(input){
          var label=input.closest('.dp-variant-option');
          if(!label) return;
          var note=label.querySelector('.dp-variant-note');
          if(note) note.textContent=(note.textContent||'').replace(/\s+/g,' ').trim();
        }

        function brand45Day(input,variant,allocation){
          var label=input.closest('.dp-variant-option');
          if(!label) return;
          var name=label.querySelector('.dp-variant-name');
          var note=label.querySelector('.dp-variant-note');
          if(!name) return;
          var raw=(name.getAttribute('data-dp-original-plan-name')||name.textContent||'').trim();
          if(!name.hasAttribute('data-dp-original-plan-name')) name.setAttribute('data-dp-original-plan-name',raw);
          if(!/45\s*day/i.test(raw)){
            flattenNote(input);
            return;
          }
          var base=Number(variant&&variant.price||0);
          var sub=allocationPrice(allocation);
          var savings=(base>0&&sub!=null&&sub<base)?Math.round((1-(sub/base))*100):0;
          if(savings>=5){
            name.textContent='Subscribe & Save '+savings+'%';
            if(note) note.textContent='Save '+savings+'% on every order. Ships every 45 days. Skip, edit, or cancel anytime.';
          }else{
            name.textContent='Subscribe Every 45 Days';
            if(note) note.textContent='Ships every 45 days. Skip, edit, or cancel anytime.';
          }
        }

        function restoreOneTimePrice(){
          var variantInput=selectedVariantInput();
          if(priceEl&&variantInput&&variantInput.getAttribute('data-price')) priceEl.textContent=variantInput.getAttribute('data-price');
          if(compareEl&&variantInput){
            var compare=variantInput.getAttribute('data-compare')||'';
            compareEl.textContent=compare;
            compareEl.style.display=compare?'':'none';
          }
        }

        function updateSelectedPrice(){
          var variant=selectedVariant();
          var selectedPlan=planInputs.find(function(input){return input.checked&&input.getAttribute('data-selling-plan-id');});
          if(!variant||!selectedPlan){restoreOneTimePrice();return;}
          var allocation=findAllocation(variant,selectedPlan.getAttribute('data-selling-plan-id'));
          var sub=allocationPrice(allocation);
          if(sub==null){restoreOneTimePrice();return;}
          if(priceEl) priceEl.textContent=money(sub);
          if(compareEl){
            var base=Number(variant.price||0);
            if(base>sub){compareEl.textContent=money(base);compareEl.style.display='';}
            else{compareEl.textContent='';compareEl.style.display='none';}
          }
        }

        function refreshPlans(){
          var variant=selectedVariant();
          if(!variant) return;
          var allocations=allocationsFor(variant);
          var hasAllocationData=Array.isArray(variant.selling_plan_allocations);
          var allowed={};
          allocations.forEach(function(a){var id=allocationPlanId(a);if(id) allowed[id]=a;});
          var selectedStillValid=true;

          planInputs.forEach(function(input){
            var pid=String(input.getAttribute('data-selling-plan-id')||'').replace(/\D/g,'');
            var label=input.closest('.dp-variant-option');
            if(!pid){if(label) label.hidden=false;return;}
            var allocation=allowed[pid]||null;
            if(hasAllocationData&&label) label.hidden=!allocation;
            if(input.checked&&!allocation&&hasAllocationData) selectedStillValid=false;
            if(allocation) brand45Day(input,variant,allocation);
          });

          if(!selectedStillValid&&oneTime){
            oneTime.checked=true;
            if(sellingPlanHidden) sellingPlanHidden.value='';
            oneTime.dispatchEvent(new Event('change',{bubbles:true}));
          }
          updateSelectedPrice();
        }

        section.querySelectorAll('input[name="id"]').forEach(function(input){input.addEventListener('change',refreshPlans);});
        planInputs.forEach(function(input){input.addEventListener('change',updateSelectedPrice);});
        refreshPlans();
      })
      .catch(function(){
        section.querySelectorAll('[data-dp-purchase-option]').forEach(flattenNote);
      });
  }

  ready(function(){
    initCartSync();
    initProductPurchaseIntegrity();
  });
})();
